import { useEffect } from "react";
import { Hero } from "@/components/site/Hero";
import { BrandPhilosophy } from "@/components/site/BrandPhilosophy";
import { SignatureCollection } from "@/components/site/SignatureCollection";
import { WhySwastik } from "@/components/site/WhySwastik";
import { DeveloperCollection } from "@/components/site/DeveloperCollection";
import { ExploreLocations } from "@/components/site/ExploreLocations";
import { PropertyFiles } from "@/components/site/PropertyFiles";
import { Consultation } from "@/components/site/Consultation";
import { StayConnected } from "@/components/site/StayConnected";
import { applySeo } from "@/lib/seo";
import { SITE_URL } from "@/data/site";

export default function Home() {
    useEffect(() => {
        applySeo({
            title: "Swastik Realty | Luxury Real Estate Advisory in Western Mumbai — Find, Trust, Grow",
            description:
                "Swastik Realty is a premium, RERA-registered luxury real estate advisory focused on Western Mumbai. Discover the city's most prestigious residences with trusted, transparent guidance.",
            canonical: `${SITE_URL}/`,
            jsonLd: {
                "@context": "https://schema.org",
                "@type": "WebSite",
                name: "Swastik Realty",
                url: `${SITE_URL}/`,
                inLanguage: "en-IN",
            },
        });
    }, []);

    return (
        <main>
            <Hero />
            <BrandPhilosophy />
            <SignatureCollection />
            <WhySwastik />
            <DeveloperCollection />
            <ExploreLocations />
            <PropertyFiles />
            <Consultation />
            <StayConnected />
        </main>
    );
}
